// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"23364ab2","58":"0374f8c3","152":"98d56d4a","207":"a6385096","219":"b3d89551","355":"4373d068","453":"5030a6a0","658":"a4c562bc","667":"ffe2d774","698":"607e7dd8","796":"64b7bcf9","813":"ae6b68dc","937":"9a8633d2"}[chunkId] + ".chunk.js";
};